import { History } from "history";
import { AdminUser } from "../constants";
import { IDataFactory } from "../models";
import { IStandardColumn } from "../models/StandardColumn";
import { isInRole } from "../service/authProvider";
import { addSortLabels, customRender, renderViewColumn } from "./utils";

export function generateDatafactoryColumns(history: History): IStandardColumn[] {
    const cols: IStandardColumn[] = [
        {
            key: "name",
            name: "Data Factory Name",
            fieldName: "name",
            filterBy: true,
            minWidth: 75,
            maxWidth: 250,
            isResizable: true,
            isSorted: true
        },
        {
            key: "type",
            name: "Type",
            fieldName: "type",
            minWidth: 50,
            maxWidth: 150,
            isResizable: true,
            filterBy: true
        },
        {
            key: "platformName",
            name: "Platform Name",
            fieldName: "platformName",
            minWidth: 50,
            maxWidth: 150,
            isResizable: true
        },
        {
            key: "resourceStatus",
            name: "Resource Status",
            fieldName: "resourceStatus",
            minWidth: 50,
            maxWidth: 150,
            isResizable: true
        },
        {
            key: "monitoringStatus",
            name: "Monitoring Status",
            fieldName: "monitoringStatus",
            minWidth: 50,
            maxWidth: 150,
            isResizable: true
        },
        {
            key: "pipelineCount",
            name: "Total Pipelines",
            fieldName: "pipelineCount",
            minWidth: 50,
            maxWidth: 100,
            isResizable: true
        }
    ];
    if (isInRole(AdminUser)) {
        cols.push({
            key: "id",
            name: "View/Edit",
            fieldName: "id",
            minWidth: 50,
            maxWidth: 50,
            isResizable: true,
            isIconOnly: false,
            onRender: (item: IDataFactory) => renderViewColumn(item, "datafactories", history)
        });
    }

    addSortLabels(cols);
    return cols;
}
